import prefillStartTimeAccordingToCode from '../../../containers/ActForm/UIOptimizations/PrefillStartTimeAccordingToCode/PrefillStartTimeAccordingToCode';

const associatedUIOptimizations = [prefillStartTimeAccordingToCode];

const prefillStartTime = { associatedUIOptimizations };

export default prefillStartTime;
